import React, { FunctionComponent, useState, useContext } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'

import { Tabs, MouseTabs, MobileTabsMouse, MobileTabs } from '../../../const/tabs';

import Header from './Header';
import { device } from '../../../const/device';
import BuilderContext from "../../../builder/hooks/context";

type Props = {
  Components: { [key: string]: FunctionComponent },
  page: string
}

function Content({ Components, page }: Props) {
  const { builder } = useContext(BuilderContext);
  const { params } = useRouteMatch<{ tabIndex: string }>();
  const [selectedItem, setSelectedItem] = useState<string>(Object.keys(Components)[params?.tabIndex ?? 0]);
  const Component = Components[selectedItem];

  const isMobile = useMediaQuery({ query: `(${device.mobileL})` });
  const tabs = isMobile ? (builder.modelData?.surffaceList?.length? MobileTabsMouse : MobileTabs) : (builder.modelData?.surffaceList?.length? MouseTabs : Tabs);

    return (
    <>
      <Header
        items={Object.keys(Components)
          .reduce((acc, item) => acc = { ...acc, [item]: tabs[page][item] }, {})
        }
        page={page}
        selectedItem={selectedItem}
        setSelectedItem={item => setSelectedItem(item)}
      />
      <Component />
    </>
  );
}

export default React.memo(Content);
